import dynamic from 'next/dynamic';

const ReveivingScan = dynamic(() => import('./Scan'), { ssr: false });
export default ReveivingScan;
